import api from '@/api'
import $log from '@/utils/log'

export default {

  namespaced: true,

  state: {
    announcements: {}
  },

  mutations: {
    SET_ANNOUNCEMENTS : ( state, announcements ) => {
      state.announcements = announcements
    },
    SET_ANNOUNCEMENT : ( state, announcement ) => {
      state.announcements[announcement.documentId] = announcement
    },
    DELETE_ANNOUNCEMENT : ( state, announcement ) => {
      delete state.announcements[announcement.documentId]
    },
  },

  getters: {
    announcements_array : state => {
      return Object.values( state.announcements )
    },
    most_recent : ( state, getters ) => {
      return getters.announcements_array[0]
    }
  },

  actions: {


    // Process and set announcement

    set_announcement( { commit, getters }, announcement ) {
      if ( !announcement.show || announcement.deleted ) {
        commit( 'DELETE_ANNOUNCEMENT', announcement )
      } else {
        commit( 'SET_ANNOUNCEMENT', announcement )
      }
    },


    // Fetch announcements by event id

    fetch_announcements( { dispatch }, event_id ) {
      return new Promise( ( resolve, reject ) =>
        api
        .announcements
        .get_by_event( event_id )
        .then( announcements => {
          for ( const announcement of announcements ) {
            dispatch( 'set_announcement', announcement )
          }
          resolve( announcements )
        } )
        .catch( error =>
          reject( error )
        )
      )
    },


    // Get announcements by event id.

    async get_announcements( { getters, dispatch }, event_id ) {
      return (
        getters.announcements_array.length ||
        await dispatch( 'fetch_announcements', event_id )
      )
    },


    // Receive announcements in real time

    socket_announcement( { dispatch }, announcement ) {
      $log.info( 'SOCKET', `Announcement ${ announcement.title }` )
      dispatch( 'set_announcement', announcement )
    },


  }

}
